<template lang="html">
    <button 
        v-if="!disabled"
        :class="{
            'square-button' : shape === 'square',
            'round-button' : shape === 'round',
            'round-button--anytime' : anytime === true,
            'square-button--sm square-button--danger': size == 'sm'
        }"
        @click="$emit('click')">

        <i v-if="icon" :class="icon"></i>
        {{name}}
    </button>

    <button v-else 
        :class="{
            'square-button square-button--disabled'  : shape === 'square',
            'round-button round-button--disabled'   : shape === 'round',
            'round-button--anytime' : anytime === true
        }">

        <i v-if="icon" :class="icon"></i>
        {{name}}
    </button>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            icon: {
                type: String,
                default: ''
            },
            shape: { // round or square
                type: String,
                default: 'round'
            },
            size: { // md or lg
                type: String,
                default: 'lg'
            },
            anytime: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
.round-button {
    width: 100%;
    margin: 5px auto;
    border-radius: 18px;
    background: $gradient-nexyo;
    font-family: 'DIN Pro', sans-serif;
    color: white;
    font-weight: 500;
    height: 35px;
    border: none;
    outline: none;
    cursor: pointer;
    max-width: 250px;
    transition: opacity .2s;

    &:hover {
        opacity: 0.7;
    }

    &:active {
        opacity: 1;
    }

    &--disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
    
    &--anytime {
        background: $color-anytime-button;
         @include media-breakpoint-down(sm) {
            max-width: 100%;
        }
    }
}

.square-button {
    width: 100%;
    height: 60px;
    font-family: "DIN Pro";
    font-weight: 700;
    font-size: 20px;
    background: transparent linear-gradient(90deg, $color-primary 0%, $color-secondary 100%) 0% 0% no-repeat padding-box;
    color: #FFFFFF;
    outline: none;
    border: none;
    cursor: pointer;
    margin-top: 30px;

    &:hover {
        border-image: $gradient-nexyo;
        border-style: solid;
        border-width: 3px;
        border-image-slice: 1;
        background: white;
        color: $color-primary;
    }
    
    &--sm {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 35px;
        font-family: "DIN Pro";
        font-weight: 500;
        font-size: 16px;
        background: $color-primary;
        border: none;
        color: #FFFFFF;
        outline: none;
        cursor: pointer;
        white-space: nowrap;
        border-radius: 0px;
    }
    
    &--danger {
        background: $color-danger;
        margin-bottom: 20px;
    }
    
    &--disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
}


</style>